// extracted by mini-css-extract-plugin
export var buttonContainer = "_8n-1";
export var fontSizeSelect = "_8n-3";
export var formatSelect = "_8n-2";
export var formats = "_8n-4";
export var hidden = "_8n-5";
export var icon = "_8n-6";
export var select = "_8n-0";